module.exports = __webpack_public_path__ + "img/s2.3d6aeb66.png";